import * as React from "react";
const SvgBank = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 14.5V8h1.5v6.5zm5.25 0V8h1.5v6.5zM2 17v-1.5h16V17zm12.5-2.5V8H16v6.5zM2 7V5l8-4 8 4v2zm2.354-1.5h11.292L10 2.688z" }));
export default SvgBank;
